export default __webpack_public_path__ + "static/media/PersonCirclewhite.263e3101.svg";